module.exports = __webpack_public_path__ + "img/ais-aton.457a1a9a.svg";